import { a, C } from "../CommonStringUtils-8860a016.js";
import "lodash";
import "moment";
export {
  a as CommonUtils,
  C as CommonUtilsInstance
};
//# sourceMappingURL=CommonUtils.js.map
